export default function (err) {
  console.log(err)
}



// WEBPACK FOOTER //
// ./src/error/index.js